import * as yup from 'yup';
import { StartupMetricsFormModel } from '../../../_types';

const isPeriodRequired = (type: StartupMetricsFormModel['type']) =>
  type === 'ignore-startup' || type === 'two-phase';

export const startupMetricsValidationSchema = yup.object({
  type: yup
    .string()
    .oneOf([
      'no-strategy',
      'two-phase',
      'ignore-startup',
    ] satisfies StartupMetricsFormModel['type'][])
    .required(),
  isCustom: yup.boolean().required(),
  min: yup
    .number()
    .required('Min is required')
    .when('type', {
      is: isPeriodRequired,
      then: (schema) =>
        schema
          .min(2, 'Must be at least 2 minutes')
          .max(60, 'Min should be between 2 and 60'),
      otherwise: (schema) => schema.nullable(),
    }),
  sec: yup
    .number()
    .required('Sec is required')
    .when('type', {
      is: isPeriodRequired,
      then: (schema) =>
        schema
          .min(0, 'Sec should be between 0 and 59')
          .max(59, 'Sec should be between 0 and 59'),
      otherwise: (schema) => schema.nullable(),
    }),
});
